<template>
    <div class="webim-external-select">
        <v-page-header
            title="客服对外形象与引流"
            level="section"
        />

        <div class="webim-external-select__main">
            <div class="webim-external-select-left">
                <style-tab
                    v-model="selectComponent"
                    :options="[{value: 'pc', text: '电脑端'}, {value: 'mobile', text: '移动端'}]"
                />
                <!-- pc -->
                <div
                    v-if="selectComponent === 'pc'"
                    class="tab-content tab-content-pc"
                >
                    <div
                        class="pc-show-block"
                    >
                        <div class="pc-show-block-right">
                            <!-- 员工信息 -->
                            <template v-if="linkInfo.externalType === 2">
                                <div class="staff-demo">
                                    <div class="staff-demo__header">
                                        <div class="logo-img-line">
                                            <img
                                                :src="require('../../../assets/recep-img.png')"
                                                alt="logo"
                                                class="logo-img"
                                            >
                                            <v-icon name="com_tag" v-if="linkInfo.isShowPersonIcon" class="com-icon"></v-icon>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <!-- 企业信息 + 自定义模块? -->
                            <template v-else>
                                <template
                                    v-if="(linkInfo.externalType === 3
                                        && linkInfo.externalMixType === 1
                                        && (templateContent.length > 0 || +linkInfo.sidebarID !== 0))
                                        || linkInfo.externalType === 1"
                                >
                                    <div class="logo-img-line">
                                        <img
                                            :src="companyLogo"
                                            alt="logo"
                                            class="logo-img"
                                        >
                                        <v-icon name="com_tag" v-if="linkInfo.isShowCompanyIcon" class="com-icon"></v-icon>
                                    </div>
                                    <div class="company-name-line ellipsis">
                                        {{ linkInfo.companyName }}
                                    </div>
                                    <div
                                        v-if="linkInfo.isSelectCompanySignature && linkInfo.companySignature"
                                        class="company-sign-line ellipsis"
                                    >
                                        {{ linkInfo.companySignature }}
                                    </div>
                                    <div
                                        v-if="linkInfo.isSelectCompanyAddress && linkInfo.companyAddress"
                                        class="icon-detail-line"
                                    >
                                        {{ linkInfo.companyAddress }}
                                        <span class="icon position-icon" />
                                    </div>
                                    <div
                                        v-if="linkInfo.isSelectCompanyEmail && linkInfo.companyEmail"
                                        class="icon-detail-line ellipsis"
                                    >
                                        {{ linkInfo.companyEmail }}
                                        <span class="icon email-icon" />
                                    </div>
                                    <div
                                        v-if="linkInfo.isSelectCompanySite && linkInfo.companySite"
                                        class="icon-detail-line ellipsis"
                                    >
                                        {{ linkInfo.companySite }}
                                        <span class="icon site-icon" />
                                    </div>
                                    <div
                                        v-if="linkInfo.isSelectCompanyPhone && linkInfo.companyPhone"
                                        class="icon-detail-line ellipsis"
                                    >
                                        {{ linkInfo.companyPhone }}
                                        <span class="icon phone-icon" />
                                    </div>
                                    <div
                                        v-if="linkInfo.isSelectCompanyIntro && linkInfo.companyIntro"
                                        class="icon-detail-line"
                                    >
                                        {{ linkInfo.companyIntro }}
                                        <span class="icon intro-icon" />
                                    </div>
                                    <!-- 自定义模板 -->
                                    <webim-hot-panel
                                        v-if="linkInfo.externalType === 3"
                                        :content="templateContent"
                                        :id="linkInfo.sidebarID"
                                    />
                                    <div v-if="pageData.data && !pageData.data.isSsc">
                                        <div
                                            v-if="isRecommendList"
                                            class="recommend-list-block"
                                        >
                                            <div class="recommend-list-label">
                                                <div class="recommend-list-vertical" />
                                                <div class="recommend-list-title">
                                                    企业推荐
                                                </div>
                                            </div>
                                            <div class="recommend-list-item-content">
                                                <div
                                                    v-for="item in linkInfo.recommendation"
                                                    :key="item.key"
                                                    class="recommend-list-item"
                                                >
                                                    <v-tip
                                                        ref="qrcode"
                                                        :gap="1"
                                                        placement="top"
                                                        kind="large"
                                                        clazz="qrcode-poper-wrapper"
                                                    >
                                                        <template slot-scope="props">
                                                            <QrcodePoper
                                                                v-if="props.data"
                                                                :img="props.data.qrUrl"
                                                                :type="props.data.type"
                                                            />
                                                            <div
                                                                v-if="props.data"
                                                                class="enterprise-cluster"
                                                            >
                                                                {{ props.data.type }}
                                                            </div>
                                                        </template>
                                                    </v-tip>
                                                    <div
                                                        v-tip:qrcode="item"
                                                        class="recommend-list-item-logo"
                                                    >
                                                        <img
                                                            :src="item.qrUrl"
                                                            alt="logo"
                                                            class="logo-img"
                                                        >
                                                    </div>
                                                    <div class="recommend-list-item-text">
                                                        <div class="recommend-name ellipsis">
                                                            {{ item.name }}
                                                        </div>
                                                        <div class="recommend-type ellipsis">
                                                            {{ item.type }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-else
                                            class="recommend-none-list"
                                        >
                                            企业推荐
                                        </div>
                                    </div>
                                </template>
                                <!-- 自定义模板 -->
                                <template
                                    v-else-if="linkInfo.externalType === 3
                                        && linkInfo.externalMixType === 2
                                        && (templateContent.length > 0 || +linkInfo.sidebarID !== 0)"
                                >
                                    <webim-hot-panel
                                        :content="templateContent"
                                        :id="linkInfo.sidebarID"
                                        class="webim-hot-panel-custom"
                                    />
                                </template>
                            </template>
                        </div>
                        <div class="trademark" />
                        <!-- 左侧AIO -->
                        <div class="pc-show-block-left">
                            <div class="pc-show-block-left-top">
                                <div class="top-name">
                                    <span v-if="linkInfo.topType === 1">{{ linkInfo.companyName }}</span>
                                    <span v-if="linkInfo.topType === 2">沈佳丽</span>
                                    <span v-if="linkInfo.topType === 3">
                                        <span v-if="linkInfo.customTopName">{{ linkInfo.customTopName }}</span>
                                        <span
                                            v-else
                                            :style="{ color: 'rgba(1, 11, 50, 0.41)' }"
                                        >请输入名称</span>
                                    </span>
                                </div>
                                <v-icon
                                    v-if="guidanceInfoForYinliu.guidanceQQ
                                        && $refs.guidanceSetting
                                        && $refs.guidanceSetting.isShowGuidanceQQBoolean
                                        && pageData.data
                                        && !pageData.data.isSsc"
                                    name="qq"
                                />
                            </div>
                            <div class="pc-show-block-left-middle">
                                <div class="chat-message-block">
                                    <div class="chat-message-block-logo">
                                        <div
                                            v-if="linkInfo.openName === 2"
                                            class="recep-name"
                                        />
                                        <img
                                            v-else-if="linkInfo.openName === 1"
                                            :src="companyLogo"
                                            alt="logo"
                                        >
                                        <template v-else>
                                            <img
                                                v-if="linkInfo.customOpenAvatar"
                                                :src="linkInfo.customOpenAvatar"
                                                alt="custom-log"
                                            >
                                            <div
                                                v-else
                                                class="default-custom-open-avatar"
                                            />
                                        </template>
                                    </div>
                                    <div class="chat-message-block-text">
                                        <div class="msg-send-info">
                                            <span v-if="linkInfo.openName === 1">
                                                {{ linkInfo.companyName }}
                                            </span>
                                            <span v-if="linkInfo.openName === 2">
                                                沈佳丽
                                            </span>
                                            <template v-if="linkInfo.openName === 3">
                                                <span v-if="linkInfo.customOpenName">{{ linkInfo.customOpenName }}</span>
                                                <span
                                                    v-else
                                                    :style="{ color: 'rgba(1, 11, 50, 0.41)' }"
                                                >请输入名称</span>
                                            </template>
                                            <v-icon
                                                v-if="guidanceInfoForYinliu.guidanceWechat"
                                                name="guidance_qr"
                                                class="guidance-qr"
                                            />
                                        </div>
                                        <div class="chat-message-block-message" />
                                    </div>
                                </div>
                            </div>
                            <div class="pc-show-block-left-bottom">
                                <div class="pc-show-block-left-bottom-send" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- mobile -->
                <div
                    v-if="selectComponent === 'mobile'"
                    class="tab-content tab-content-mobile"
                >
                    <div class="mobile-show-block">
                        <v-icon
                            name="new_mobile_guidance"
                            class="mobile-show-block__bg"
                        />
                        <div class="top-name">
                            <span v-if="linkInfo.topType === 1">{{ linkInfo.companyName }}</span>
                            <span v-if="linkInfo.topType === 2">沈佳丽</span>
                            <span v-if="linkInfo.topType === 3">
                                <span v-if="linkInfo.customTopName">{{ linkInfo.customTopName }}</span>
                                <span
                                    v-else
                                    :style="{ color: 'rgba(1, 11, 50, 0.41)' }"
                                >请输入名称</span>
                            </span>
                        </div>
                        <div v-if="channelType !== 1" class="mobile-guidance-qq">
                            <v-icon
                                v-if="guidanceInfoForYinliu.guidanceQQ
                                    && $refs.guidanceSetting
                                    && $refs.guidanceSetting.isShowGuidanceQQBoolean
                                    && pageData.data
                                    && !pageData.data.isSsc"
                                name="qq_fill"
                            />
                        </div>
                        <div class="chat-message-block">
                            <div class="chat-message-block-logo">
                                <div
                                    v-if="linkInfo.openName === 2"
                                    class="recep-name"
                                />
                                <img
                                    v-else-if="linkInfo.openName === 1"
                                    :src="companyLogo"
                                    alt="logo"
                                >
                                <template v-else>
                                    <img
                                        v-if="linkInfo.customOpenAvatar"
                                        :src="linkInfo.customOpenAvatar"
                                        alt="custom-log"
                                    >
                                    <div
                                        v-else
                                        class="default-custom-open-avatar"
                                    />
                                </template>
                            </div>
                            <div class="chat-message-block-text">
                                <div class="msg-send-info">
                                    <span v-if="linkInfo.openName === 1">
                                        {{ linkInfo.companyName }}
                                    </span>
                                    <span v-if="linkInfo.openName === 2">
                                        沈佳丽
                                    </span>
                                    <template v-if="linkInfo.openName === 3">
                                        <span v-if="linkInfo.customOpenName">{{ linkInfo.customOpenName }}</span>
                                        <span
                                            v-else
                                            :style="{ color: 'rgba(1, 11, 50, 0.41)' }"
                                        >请输入名称</span>
                                    </template>
                                    <v-icon
                                        v-if="channelType !== 1 && guidanceInfoForYinliu.guidanceWechat"
                                        name="guidance_qr"
                                        class="guidance-qr"
                                    />
                                </div>
                                <div class="chat-message-block-message" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="webim-external-select-right">
                <div class="webim-external-select-right__radio-block first-radio-block">
                    <v-page-header
                        level="content"
                        title="选择对外企业"
                    />
                    <div class="webim-external-select__radio company-select">
                        <div class="flex-box">
                            <div class="group-left-label">
                                企业名称
                            </div>
                            <common-select
                                :value="linkInfo.corpType ? [linkInfo.relatedCorpID] : ['maincorp']"
                                :select-required="false"
                                :maps="maps"
                                :max-level="1"
                                :count="20"
                                :select-all-btn="false"
                                :list-function="onFetchCompanyList"
                                @confirm="onSelectCompany"
                                refresh-btn
                                save-selected-switch
                                search-placeholder="企业名称"
                                clazz="company-select-panel"
                            >
                                <template
                                    slot="list-item"
                                    slot-scope="props"
                                >
                                    <div class="company-select-item">
                                        <cell
                                            :text="props.item.companyName"
                                            :highlight-text="props.searchValue"
                                            :key="props.item.relatedCorpID"
                                            pattern="icon_text"
                                            class="company-select-item-cell"
                                        />
                                    </div>
                                </template>
                                <template slot="trigger">
                                    <v-form>
                                        <v-form-item
                                            :error-placement="'bottom'"
                                            name="companyName"
                                        >
                                            <v-input
                                                :value="linkInfo.companyName"
                                                :clearable="false"
                                                name="companySelect"
                                                placeholder="请选择"
                                                readonly
                                                class="company-select-trigger"
                                            >
                                                <template slot="right-icon">
                                                    <v-icon
                                                        name="arrow_down_small_line"
                                                        remote
                                                    />
                                                </template>
                                            </v-input>
                                        </v-form-item>
                                    </v-form>
                                </template>
                            </common-select>
                        </div>
                    </div>
                </div>
                <div v-if="channelType !== 1" class="webim-external-select-right__radio-block first-radio-block">
                    <v-page-header
                        level="content"
                        title="顶部导航对外形象"
                    />
                    <div class="webim-external-select__radio">
                        <div class="flex-box">
                            <div class="group-left-label">
                                方式
                            </div>
                            <v-radio-group v-model="linkInfo.topType">
                                <v-radio
                                    :value="1"
                                    name="webim-external"
                                >
                                    企业简称
                                </v-radio>
                                <v-radio
                                    :value="2"
                                    name="webim-external"
                                >
                                    <span class="webim-external-select__radio-label">
                                        员工名称
                                        <v-icon
                                            v-tip:externalTopTip.hover
                                            :style="{ width: '16px', height: '16px' }"
                                            name="basic_help_line_temp"
                                        />
                                    </span>
                                </v-radio>
                                <v-radio
                                    :value="3"
                                    name="webim-external"
                                >
                                    自定义
                                </v-radio>
                                <v-tip
                                    ref="externalTopTip"
                                    placement="top"
                                    kind="small"
                                >
                                    <div :style="{ padding: '8px' }">
                                        若当前未分配客服时，则顶部对外名称显示为“在线客服”
                                    </div>
                                </v-tip>
                            </v-radio-group>
                        </div>
                        <v-form
                            v-if="linkInfo.topType === 3"
                            class="webim-external-select__radio__form"
                        >
                            <v-form-item
                                :error-placement="'bottom'"
                                v-model="customTopNameForm.customTopName.error"
                                :rules="customTopNameForm.customTopName.rule"
                                name="customTopName"
                                label="自定义名称"
                            >
                                <v-input
                                    v-model="linkInfo.customTopName"
                                    :maxlength="12"
                                    name="customTopName"
                                    placeholder="请输入"
                                    required
                                />
                            </v-form-item>
                        </v-form>
                        <StaffChangeInfoComment
                            v-if="linkInfo.topType == 2"
                            :open="0"
                        >
                            接入后展示员工对外昵称员工可在【客户端-对外资料】中修改
                        </StaffChangeInfoComment>
                    </div>
                </div>
                <div class="webim-external-select-right__radio-block first-radio-block">
                    <v-page-header
                        title="对话框内对外形象"
                        level="content"
                    />
                    <div class="webim-external-select__radio">
                        <div class="flex-box">
                            <div class="group-left-label">
                                方式
                            </div>
                            <v-radio-group v-model="linkInfo.openName">
                                <v-radio
                                    :value="1"
                                    name="webim-external"
                                >
                                    企业简称+企业logo
                                </v-radio>
                                <v-radio
                                    :value="2"
                                    name="webim-external"
                                >
                                    员工名称+员工头像
                                </v-radio>
                                <v-radio
                                    :value="3"
                                    name="webim-external"
                                >
                                    自定义
                                </v-radio>
                            </v-radio-group>
                        </div>
                        <v-form
                            v-if="linkInfo.openName === 3"
                            class="webim-external-select__radio__form"
                        >
                            <v-form-item
                                :error-placement="'bottom'"
                                v-model="customOpenNameForm.customOpenName.error"
                                :rules="customOpenNameForm.customOpenName.rule"
                                label="自定义名称"
                                name="top-name"
                            >
                                <v-input
                                    v-model="linkInfo.customOpenName"
                                    :maxlength="12"
                                    name="customOpenName"
                                    placeholder="请输入"
                                    required
                                />
                            </v-form-item>
                            <v-form-item
                                :error-placement="'bottom'"
                                name="customOpenAvatar"
                                label="自定义头像"
                            >
                                <ExtraSelectInput
                                    @click="handleAvatarSelect"
                                    :selected="linkInfo.customOpenAvatar"
                                    :isAvatorSelector="true"
                                    required
                                />
                            </v-form-item>
                        </v-form>
                        <StaffChangeInfoComment
                            v-if="linkInfo.openName == 2"
                            :open="0"
                        >
                            接入后展示员工对外昵称员工可在【客户端-对外资料】中修改
                        </StaffChangeInfoComment>
                    </div>
                </div>
                <div
                    v-if="channelType !== 1"
                    class="webim-external-select-right__radio-block first-radio-block"
                >
                    <v-page-header
                        title="侧边栏对外形象与资料"
                        level="content"
                    />
                    <div class="webim-external-select__radio">
                        <div class="flex-box">
                            <div class="group-left-label">
                                方式
                            </div>
                            <v-radio-group v-model="linkInfo.externalType">
                                <v-radio
                                    :value="1"
                                    name="webim-external"
                                >
                                    企业统一形象
                                </v-radio>
                                <v-radio
                                    :value="2"
                                    name="webim-external"
                                >
                                    员工个人形象
                                </v-radio>
                                <v-radio
                                    v-if="sidebarPermission"
                                    :value="3"
                                    name="webim-external"
                                >
                                    自定义
                                </v-radio>
                            </v-radio-group>
                        </div>
                    </div>
                </div>
                <!-- 侧边栏对外形象与资料 内容 -->
                <template v-if="channelType !== 1">
                    <!-- 对外资料展示-自定义 -->
                    <template v-if="linkInfo.externalType == 3 && sidebarPermission">
                        <v-form class="webim-external-select-right__custom-sidebar">
                            <v-form-item
                                :error-placement="'bottom'"
                                name="customType"
                                label="选择形象组合"
                            >
                                <template
                                    slot="label"
                                    slot-scope="prop"
                                >
                                    {{ prop.label }}
                                    <span class="item-required">*</span>
                                </template>
                                <v-select
                                    :value="linkInfo.externalMixType"
                                    :options="customSidebarOptions"
                                    @change="onChangeSidebarType($event)"
                                />
                            </v-form-item>
                            <p
                                v-if="linkInfo.externalMixType === 1"
                                class="setting-tip"
                            >
                                企业形象请至企业统一形象内配置
                            </p>
                            <v-form-item
                                ref="templateSelector"
                                :error-placement="'bottom'"
                                name="selectTemplate"
                                label="选择自定义模版"
                                class="select-sidebar-template"
                            >
                                <v-input
                                    :value="sidebarName"
                                    :clearable="false"
                                    @click.native="handleQYXXSelect"
                                    name="selectTemplate"
                                    placeholder="请选择"
                                    readonly
                                    required
                                    class="sidebar-template-trigger"
                                >
                                    <template slot="right-icon">
                                        <v-icon
                                            name="arrow_down_small_line"
                                            remote
                                        />
                                    </template>
                                </v-input>
                            </v-form-item>
                            <v-form-item
                                :error-placement="'bottom'"
                                name="mangeTemplate"
                                label="管理自定义模版"
                            >
                                <a
                                    href="/tp/IMAccessSet/sidebarList"
                                    target="_blank"
                                    class="change-basic"
                                >管理</a>
                            </v-form-item>
                        </v-form>
                    </template>
                    <template v-else-if="linkInfo.externalType == 1">
                        <div class="webim-external-select-right__basic-info">
                            <div class="sub-title">
                                基础资料 <a
                                    href="/mng/account/corpInfo"
                                    target="_blank"
                                    class="change-basic"
                                >修改</a>
                            </div>
                            <div class="checkbox-line">
                                <v-checkbox
                                    v-model="linkInfo.isSelectCompanySignature"
                                    label="企业签名"
                                />
                                <div class="checkbox-desc">
                                    {{ linkInfo.companySignature }}
                                    <div v-if="linkInfo.isSelectCompanySignature && linkInfo.companySignature == ''">
                                        <v-icon
                                            v-tip:hint.hover.delay
                                            name="input_question"
                                            class="question-mark"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="checkbox-line">
                                <v-checkbox
                                    v-model="linkInfo.isSelectCompanyAddress"
                                    label="企业地址"
                                />
                                <div class="checkbox-desc">
                                    {{ linkInfo.companyAddress }}
                                    <div v-if="linkInfo.isSelectCompanyAddress && linkInfo.companyAddress == ''">
                                        <v-icon
                                            v-tip:hint.hover.delay
                                            name="input_question"
                                            class="question-mark"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="checkbox-line">
                                <v-checkbox
                                    v-model="linkInfo.isSelectCompanyEmail"
                                    label="电子邮箱"
                                />
                                <div class="checkbox-desc">
                                    {{ linkInfo.companyEmail }}
                                    <div v-if="linkInfo.isSelectCompanyEmail && linkInfo.companyEmail == ''">
                                        <v-icon
                                            v-tip:hint.hover.delay
                                            name="input_question"
                                            class="question-mark"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="checkbox-line">
                                <v-checkbox
                                    v-model="linkInfo.isSelectCompanySite"
                                    label="企业主页"
                                />
                                <div class="checkbox-desc">
                                    {{ linkInfo.companySite }}
                                    <div v-if="linkInfo.isSelectCompanySite && linkInfo.companySite == ''">
                                        <v-icon
                                            v-tip:hint.hover.delay
                                            name="input_question"
                                            class="question-mark"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="checkbox-line">
                                <v-checkbox
                                    v-model="linkInfo.isSelectCompanyPhone"
                                    label="联系电话"
                                />
                                <div class="checkbox-desc">
                                    {{ linkInfo.companyPhone }}
                                    <div v-if="linkInfo.isSelectCompanyPhone && linkInfo.companyPhone == ''">
                                        <v-icon
                                            v-tip:hint.hover.delay
                                            name="input_question"
                                            class="question-mark"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="checkbox-line">
                                <v-checkbox
                                    v-model="linkInfo.isSelectCompanyIntro"
                                    label="企业简介"
                                />
                                <div
                                    v-if="linkInfo.isSelectCompanyIntro && linkInfo.companyIntro == ''"
                                    class="introduction"
                                >
                                    <v-icon
                                        v-tip:hint.hover.delay
                                        name="input_question"
                                        class="question-mark"
                                    />
                                </div>
                                <div
                                    ref="companyIntro"
                                    v-tip:companyIntroBlock.hover
                                    v-else
                                    class="checkbox-desc"
                                >
                                    {{ linkInfo.companyIntro }}
                                </div>
                                <v-tip
                                    ref="companyIntroBlock"
                                    :disabled="disabledIntro"
                                    kind="large"
                                    placement="top"
                                    clazz="checkbox-desc-block"
                                >
                                    {{ linkInfo.companyIntro }}
                                </v-tip>
                            </div>
                            <v-tip
                                ref="hint"
                                :gap="10"
                                placement="top"
                                kind="small"
                                clazz="question-hint"
                            >
                                <span>资料为空，请点击“修改”前往填写</span>
                            </v-tip>
                        </div>

                        <div class="webim-external-select-right__recommendation-block company-certification-block">
                            <com-per-icon
                                :icon-value="linkInfo.isShowCompanyIcon"
                                @change="val => getIconValue(val, 'isShowCompanyIcon')"
                            />
                        </div>
                    </template>
                    <StaffChangeInfoComment
                        v-else
                        :open="1"
                        :icon-value="linkInfo.isShowPersonIcon"
                        @change="val => getIconValue(val, 'isShowPersonIcon')"
                    />
                    <template v-if="linkInfo.externalType == 1 && pageData.data && !pageData.data.isSsc && env != 'private'">
                        <div class="webim-external-select-right__radio-block company-recommend-block first-radio-block">
                            <v-page-header
                                title="企业推荐"
                                level="content"
                            />
                            <div class="webim-external-select-right__recommendation-block">
                                <div class="headline">
                                    <div class="sub-title">
                                        企业推荐
                                        <div class="desc-content">
                                            绑定<a
                                                href="/mp/accountInfo"
                                                target="_blank"
                                                class="change-basic"
                                            >公众号</a>、
                                            <a
                                                href="/mp/miniprogram"
                                                target="_blank"
                                                class="change-basic"
                                            >小程序</a>或
                                            <a
                                                href="/cl/GroupMng"
                                                target="_blank"
                                                class="change-basic"
                                            >企业群</a>
                                            ，访客可扫描二维码关注或申请进群
                                        </div>
                                    </div>
                                </div>
                                <v-popper
                                    ref="selectRecommend"
                                    :offset="100"
                                    @visibleChange="visibleChange"
                                    placement="bottom"
                                    clazz="v-popper--demo"
                                >
                                    <search-tree-component
                                        ref="treeSelect"
                                        :select-data="recommendationData"
                                        :is-single="false"
                                        :channel-ids="channelIds"
                                        @handleSave="updateRecommendList"
                                        placeholder="搜索已绑定公众号、小程序、企业群"
                                        max-select="6"
                                    />
                                </v-popper>
                                <div class="recommendation-block">
                                    <div
                                        v-if="linkInfo.recommendation.length === 0"
                                        class="none-recommend"
                                    >
                                        <div class="add-button-line">
                                            <div class="recommend-qrcode" />
                                            <span
                                                v-popper:selectRecommend.click
                                                class="link-text"
                                            >添加</span>
                                        </div>
                                    </div>
                                    <div
                                        v-else
                                        class="recommend-list"
                                    >
                                        <div
                                            v-for="(item, index) in linkInfo.recommendation"
                                            :key="index"
                                            class="recommend-item"
                                        >
                                            <div
                                                @click="deleteRecommend(index)"
                                                class="recommend-item-delete"
                                            />
                                            <div class="recommend-item__left">
                                                <img
                                                    :src="item.qrUrl"
                                                    alt="推荐二维码"
                                                    class="recommend-item__left-img"
                                                >
                                            </div>
                                            <div class="recommend-item__right">
                                                <template>
                                                    <div class="recommend-name-text">
                                                        {{ item.name }}
                                                    </div>
                                                </template>
                                                <div class="recommend-type-text">
                                                    {{ item.type }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="recommend-change-button-row">
                                            <div class="recommend-change-button-qrcode" />
                                            <div
                                                v-popper:selectRecommend.click
                                                class="recommend-change-button"
                                            >
                                                {{ addRevise }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <!-- 客户引流 -->
                <guidance
                    v-if="channelType !== 1"
                    ref="guidanceSetting"
                    v-model="guidanceInfoForYinliu"
                    :disableKfuin="disableKfuin"
                    :channelIds="channelIds"
                    class="webim-external-select-right__radio-block"
                />
            </div>
            <img-select-panel
                :show="isShowImgSelectPanel"
                @handler-ok="handleImgSelectConfirm"
                @handler-cancel="isShowImgSelectPanel = false"
            />

            <img-cropper-panel
                :key="timer"
                :panel-open="isShowImgCropperPanel"
                :panel-width="630"
                :panel-height="570"
                :width="630"
                :height="408"
                :src="cropperUrl"
                :ratio="520 / 418"
                :keep-ratio="true"
                :cropper-scale="2"
                @confirm="handleImgCropperConfirm"
                @cancel="handleImgCropperCancel"
                kind="circle"
                panel-title="选择展示范围"
            />

            <select-hot-panel-model
                v-model="isShowSelectHotPanel"
                :selected-id="linkInfo.sidebarID"
                :permission="sidebarPermission ? 1 : 0"
                @select="handleModelSelect"
                title="选择自定义模板"
            />
        </div>
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';
import { isPrivate } from '@/common/config';
import SearchTreeComponent from '../../search-tree-component/index';
import QrcodePoper from '../../qrcode-poper';
import StaffChangeInfoComment from '../../staff-change-info-comment';
import ComPerIcon from '../../compny-person-icon.vue';
import ExtraSelectInput from '../extra-select-input/Index.vue';
import ImgSelectPanel from '@/components/img-select-panel/index';
import ImgCropperPanel from '@/components/img-cropper-panel/index';
import SelectHotPanelModel from 'src/components/select-hot-panel-model';
import WebimHotPanel from 'src/components/webim-hot-panel';
import Guidance from '../guidance';
import StyleTab from '../../style-tab';
import CommonSelect from 'src/components/market-common-select-panel';
import Cell from 'src/components/cell';

const DEFAULT_COMPANY_AVATAR = require('../../../assets/default-company-avatar.png');

export default {
    components: {
        SearchTreeComponent,
        StaffChangeInfoComment,
        QrcodePoper,
        ComPerIcon,
        ExtraSelectInput,
        ImgSelectPanel,
        ImgCropperPanel,
        SelectHotPanelModel,
        WebimHotPanel,
        Guidance,
        StyleTab,
        CommonSelect,
        Cell,
    },
    inject: ['channelType'],
    props: {
        externalData: {
            type: Object,
            default: () => {},
        },
        channelIds: {
            type: Array,
            default: () => [],
        },
        disableKfuin: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            env: window.pageData.env,
            linkInfo: {
                externalType: 1,
                companyName: '', // 企业简称
                companyLogo: '',
                companySignature: '',
                companyAddress: '',
                companyEmail: '',
                topType: 1, // 顶部对外名称
                customTopName: '',
                openName: 1, // 左侧对外名称
                customOpenName: '',
                customOpenAvatar: '',
                staffName: '-',
                staffUrl: '-',
                companySite: '',
                companyPhone: '',
                companyIntro: '',
                sidebarID: '0', // 选中的自定义模板id
                externalMixType: 0, // 选中的自定义模版类型 1-企业形象+自定义模版 2-自定义模版
                relatedCorpID: '0', // 关联企业id
                corpType: 0, // 0-表示主体企业，1-表示关联企业
                isSelectCompanySignature: true,
                isSelectCompanyAddress: true,
                isSelectCompanyEmail: true,
                isSelectCompanySite: true,
                isSelectCompanyPhone: true,
                isSelectCompanyIntro: true,
                isShowCompanyIcon: true,
                isShowPersonIcon: true,
                recommendation: [],
            },
            // 引流数据
            guidanceInfoForYinliu: {},
            customTopNameForm: {
                customTopName: {
                    rule: [
                        { required: true, message: '名称不能为空', trigger: 'blur' },
                        { maxLength: 12, message: '最多12个字', trigger: 'blur' },
                    ],
                    error: '',
                },
            },
            customOpenNameForm: {
                customOpenName: {
                    rule: [
                        { required: true, message: '名称不能为空' },
                        { maxLength: 12, message: '最多12个字' },
                    ],
                    error: '',
                },
            },
            disabledIntro: false,
            addRevise: '添加/修改',
            sidebarPermission: false,
            isShowImgSelectPanel: false,
            isShowImgCropperPanel: false,
            isShowSelectHotPanel: false,
            templateContent: [], // 侧边栏自定义模版内容
            cropperUrl: '',
            timer: 1,
            pageData: Object.freeze(window.pageData),

            // 自定义模版类型选项
            customSidebarOptions: [
                {
                    text: '企业形象+自定义模版',
                    value: 1,
                },
                {
                    text: '仅自定义模版',
                    value: 2,
                },
            ],
            default_company_avatar: DEFAULT_COMPANY_AVATAR,
            selectComponent: 'pc',
            sidebarName: '',
            maps: {
                value: 'relatedCorpID',
                text: 'companyName',
            },
        };
    },

    computed: {
        isRecommendList() {
            const { recommendation } = this.linkInfo;
            return recommendation && recommendation.length > 0;
        },
        isShowCompanyName() {
            const { externalType, openName } = this.linkInfo;
            return externalType === 2 && openName === 1;
        },
        isShowStaffName() {
            const { externalType, openName } = this.linkInfo;
            return externalType === 2 && openName === 2;
        },
        recommendationData() {
            const { recommendation } = this.linkInfo;
            return recommendation.map(data => ({ ...data }));
        },
        companyLogo() {
            if (!this.linkInfo.companyLogo || +this.linkInfo.companyLogo === 0) {
                return this.default_company_avatar;
            }
            return this.linkInfo.companyLogo;
        },
    },

    watch: {
        externalData(nextValue) {
            this.linkInfo = nextValue.linkInfo;
            this.guidanceInfoForYinliu = nextValue.guidanceInfoForYinliu;

            this.$nextTick(() => {
                const dom = this.$refs.companyIntro;
                if (dom) {
                    this.disabledIntro = dom.clientWidth === dom.scrollWidth;
                }
            });
        },
        linkInfo: {
            handler(newData) {
                this.$emit('getNowData', newData, 'linkInfo');
                const { topType, openName } = newData;
                if (topType !== 3) {
                    this.customTopNameForm.customTopName.error = '';
                }
                if (openName !== 3) {
                    this.customOpenNameForm.customOpenName.error = '';
                }
            },
            deep: true,
        },
        guidanceInfoForYinliu: {
            handler(newData) {
                this.$emit('getNowData', newData, 'guidanceInfoForYinliu');
            },
            deep: true,
        },
        'linkInfo.recommendation'(val) {
            if (val.length === 6) {
                this.addRevise = '修改';
            } else {
                this.addRevise = '添加/修改';
            }
        },
        'customTopNameForm.customTopName.error'(val, oldVal) {
            if (val === oldVal) return;
            this.$emit('setErrors', 'externalData', Boolean(val));
        },
        'customOpenNameForm.customOpenName.error'(val, oldVal) {
            if (val === oldVal) return;
            this.$emit('setErrors', 'externalData', Boolean(val));
        },
        'linkInfo.externalType'(val) {
            // 当侧边栏对外形象与资料选到【自定义】时 再请求已选择的模板内容
            if (val === 3 && +this.linkInfo.sidebarID !== 0 && !this.sidebarName) {
                this.requestTemplateContent();
            }
        },
    },
    created() {
        this.getSidebarPermission();

        // 有时候externalData传入之后没有触发watch 会导致初始化数据拿不到，因此在这里初始化一下数据
        if (this.externalData.linkInfo) {
            this.linkInfo = this.externalData.linkInfo;
        }
        if (this.externalData.guidanceInfoForYinliu) {
            this.guidanceInfoForYinliu = this.externalData.guidanceInfoForYinliu;
        }
    },
    methods: {
        getSidebarPermission() {
            if (isPrivate) {
                this.sidebarPermission = false;
            } else {
                Gateway.post('/receptionConf/privilege/check', {
                    id: [177],
                    logic: 1,
                    source: 1,
                }).then((data) => {
                    this.sidebarPermission = data.ok;
                });
            }
        },
        getIconValue(val, type) {
            this.linkInfo[type] = val;
        },
        visibleChange(val) {
            this.$refs.treeSelect.visibleChange(val);
        },
        saveData() {
            this.$emit('getWebImExternalData', {
                linkInfo: this.linkInfo,
                guidanceInfoForYinliu: this.guidanceInfoForYinliu,
            });
        },
        updateRecommendList(arrData, map) {
            const rawData = arrData.map(data => map.get(data));
            const order = {
                企业公众号: 0,
                企业小程序: 1,
                企业群: 2,
            };
            rawData.sort((a, b) => order[a.type] - order[b.type]);
            this.linkInfo.recommendation = rawData;
        },
        deleteRecommend(value) {
            this.linkInfo.recommendation.splice(value, 1);
        },
        handleImgSelectConfirm(data) {
            this.cropperUrl = data.url;

            this.isShowImgSelectPanel = false;
            this.isShowImgCropperPanel = true;
            this.timer = new Date().getTime();
        },

        handleImgCropperConfirm(url) {
            this.isShowImgCropperPanel = false;
            this.$set(this.linkInfo, 'customOpenAvatar', url);
        },

        handleImgCropperCancel() {
            this.isShowImgCropperPanel = false;
        },

        // 选择自定义模版类型
        onChangeSidebarType(value) {
            this.$set(this.linkInfo, 'externalMixType', value);
        },

        // 选择自定义模板
        handleModelSelect(tpl) {
            this.linkInfo.sidebarID = tpl.id;
            this.templateContent = tpl.content;
            this.sidebarName = tpl.name;
            this.$refs.templateSelector.currentError = '';
        },
        // 获取自定义模板内容
        requestTemplateContent() {
            const detailURL = '/receptionConf/sidebar/template/detail';
            const params = { id: this.linkInfo.sidebarID };
            const success = (res) => {
                if (res.code !== 0) {
                    // 180092 自定义模板不存在
                    if (res.code === 180092) {
                        this.linkInfo.sidebarID = '0';
                        this.$refs.templateSelector.currentError = '自定义模板已被删除，请重新选择';
                        return;
                    }
                    throw new Error(res.message);
                }

                let { content } = res.data;
                if (typeof content === 'string') {
                    try {
                        content = JSON.parse(content);
                    } catch (e) {
                        content = [];
                        this.$message.error(`解析自定义侧边栏模板出错: ${e.message}`);
                    }
                }
                this.templateContent = content;
                this.sidebarName = res.data.name;
            };
            const failed = err => this.$message.error(err.message);

            this.$ajax
                .gatewayGet(detailURL, { params })
                .then(success)
                .catch(failed);
        },

        async onFetchCompanyList(index, size, keywords) {
            const params = {
                index,
                size,
                keywords,
            };
            const [mainCompanyInfo = {}, relatedCompanyInfoList = []] = await Promise.all([
                this.getMainCompanyInfo(),
                this.getRelatedCompanyInfoList(params),
            ]);

            // 需要把主体企业插在列表最前面
            // 1. 当不是搜索时 主体企业放在最前面
            // 2. 当搜索时 需要前端根据关键字自行判断搜索结果是否添加主体企业 因为后端接口只会返回包含关键字的关联企业
            if (index === 1 && (keywords === '' || mainCompanyInfo.companyName.includes(keywords))) {
                relatedCompanyInfoList.unshift(mainCompanyInfo);
            }

            return relatedCompanyInfoList;
        },

        getMainCompanyInfo() {
            return this.$ajax.gatewayPost('/v1/basic/corp/corp/corpInfoForIMWindow')
                .then(({ code, data, message }) => {
                    if (code !== 0) {
                        throw new Error(message || '获取企业信息失败');
                    }

                    const mainCompanyInfo = {
                        relatedCorpID: 'maincorp',
                        companyName: data.companyShortName,
                        companySignature: data.companySignature,
                        companyAddress: data.address,
                        companyEmail: data.companyEmail,
                        companySite: data.companyPage,
                        companyPhone: data.companyCall,
                        companyIntro: data.companyIntroduce,
                        companyLogo: data.companyIcon,
                        corpType: 0, // 0-表示主体企业，1-表示关联企业
                    };
                    return mainCompanyInfo;
                })
                .catch(() => {
                    this.$message.error('获取企业信息失败');
                    return {};
                });
        },

        getRelatedCompanyInfoList(params) {
            return this.$ajax
                .gatewayPost('/v1/basic/corp/corp/relatedCorpList', params)
                .then(({ code, data, message }) => {
                    if (code !== 0) {
                        throw new Error(message || '获取企业信息失败');
                    }

                    const relatedCorpInfo = data.related_corp_info;
                    const relatedCompanyInfoList = (relatedCorpInfo || []).map(item => (
                        {
                            relatedCorpID: item.related_id,
                            companyName: item.short_name,
                            companySignature: item.signature,
                            companyAddress: item.address_detail,
                            companyEmail: item.email,
                            companySite: item.home,
                            companyPhone: item.phone,
                            companyIntro: item.desc,
                            companyLogo: item.avatar,
                            corpType: 1, // 0-表示主体企业，1-表示关联企业
                        }
                    ));
                    return relatedCompanyInfoList || [];
                })
                .catch(() => {
                    this.$message.error('获取企业信息失败');
                    return [];
                });
        },

        onSelectCompany(value) {
            const [company] = value.options;
            delete company.expand;
            delete company.isFolder;
            delete company.tcid;
            if (company.corpType === 0) {
                // 在列表中每项需要唯一id 但是后端说关联企业的id也可能会是0 所以对主体企业的id做了特殊处理 保证不会与关联企业id重复
                // 这里在提交数据的时候再转成默认值 否则接口校验不通过 主体企业时后端读取的是corpType 不读取relatedCorpID
                company.relatedCorpID = '0';
            }
            this.linkInfo = { ...this.linkInfo, ...company };
        },

        handleAvatarSelect() {
            // this.$message.error('系统维护'); return;
            this.isShowImgSelectPanel = true;
        },

        handleQYXXSelect() {
            // this.$message.error('系统维护'); return;
            this.isShowSelectHotPanel = true;
        },

        showDisabledReason() {
            // this.$message.error('系统维护'); return;
        },
    },
};
</script>

<style lang="less">
@import 'style.less';
</style>
